import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import ic403Dark from "../../assets/icons/ic_403_dark.svg";
import ic403Light from "../../assets/icons/ic_403_light.svg";
import { MODULE_ROUTE } from "../../routers/module-router";
import { IRootState } from "../../store";

const UnauthorizedPage = () => {
  const isDark = useSelector(
    (state: IRootState) =>
      state.themeConfig.theme === "dark" || state.themeConfig.isDarkMode
  );

  return (
    <div
      className={`relative flex min-h-screen items-center justify-center overflow-hidden ${
        isDark ? "bg-black" : "bg-light"
      }`}
    >
      {" "}
      <div className="px-6 py-16 text-center font-semibold before:container before:absolute before:left-1/2 before:-translate-x-1/2 before:rounded-full before:bg-[linear-gradient(180deg,#4361EE_0%,rgba(67,97,238,0)_50.73%)] before:aspect-square before:opacity-10 md:py-20">
        <div className="relative">
          <img
            src={isDark ? ic403Dark : ic403Light}
            alt="404"
            className="mx-auto -mt-5 w-full max-w-lg object-cover md:-mt-14 md:max-w-2xl"
          />
          <p
            className={`mt-5 text-base  uppercase ${
              isDark ? "text-white" : "text-black"
            }`}
          >
            403 - Bạn không có quyền truy cập!
          </p>
          <Link
            to={MODULE_ROUTE.DASHBOARD}
            className="btn btn-gradient mx-auto !mt-7 w-max border-0 uppercase shadow-none"
            onClick={() => {
              const selectedKeys = ["/"];
              localStorage.setItem(
                "sidebar_state",
                JSON.stringify(selectedKeys)
              );
            }}
          >
            Trang chủ
          </Link>
        </div>
      </div>
    </div>
  );
};

export default UnauthorizedPage;
